import { render, staticRenderFns } from "./form.vue?vue&type=template&id=2cb936cc"
import script from "./form.js?vue&type=script&lang=js&external"
export * from "./form.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports